// extracted by mini-css-extract-plugin
export const root = "fc-content-block-with-media-module--root--1gQcq";
export const media = "fc-content-block-with-media-module--media--2DkiT";
export const mediaRight = "fc-content-block-with-media-module--mediaRight--S2ck1";
export const text = "fc-content-block-with-media-module--text--2_Xb9";